import type {
  DocumentOwnerType,
  VendorProfileDocument,
} from "../types";

export function findDocument(
  documents: VendorProfileDocument[] | undefined,
  ownerType: DocumentOwnerType,
  ownerId: string,
  documentType: string,
): VendorProfileDocument | undefined {
  return documents?.find(
    (d) =>
      d.owner_type === ownerType &&
      d.owner_id === ownerId &&
      d.document_type === documentType,
  );
}
